module.exports = __webpack_public_path__ + "img/recordBg.dd087910.png";